import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    test: [],
    count: 0,
    catalogs: [],
    selectedCatid: -1,
    currentDoc: {}
  },
  mutations: {

    // test
    test (state, data) {
      state.test.push({ num: data, ukl: 2 })
    },
    // test
    increment (state, data) {
      state.count += data
    },
    // 菜单信息
    setCatalogs (state, data) {
      state.catalogs = data
    },
    // 当前菜单ID
    setSelectedCatid (state, data) {
      state.selectedCatid = data
    },
    // 当前文章
    setCurrentDoc (state, data) {
      state.currentDoc = data
    }
  },
  getters: {
    currentPath: state => {
      return state.catalogs
    }
  }
})

export default store
